import { createGlobalStyle } from 'styled-components';
import { Colors, FontSize, FontWeight, LineHeight } from './Variables';

export const GlobalStyle = createGlobalStyle`
    html {
        margin:0; 
        padding:0; 
        min-height:100%; 
        overflow-x: hidden;
        font-family: 'Roboto', sans-serif;
    }

    body {
        min-height:100%;
        width:100%;
        overflow-x: hidden;
        float:left;
        position:relative;
        margin:0px;
        padding:0px 0px 0 0px;
        outline: 0;
        box-sizing: border-box;
        font-family: 'Roboto', sans-serif !important;
        font-weight:${FontWeight.normal};
        font-size: ${FontSize.normal};
        color: ${Colors.mainText};
        line-height: ${LineHeight.normal};
        background: ${Colors.white};
        -webkit-text-size-adjust: 100%;
        -moz-text-size-adjust: none;
        -ms-text-size-adjust: 100%;

    }

    input, button, textarea, select, optgroup {
        font-family: 'Roboto', sans-serif; 
    }

    input[type=time] {
        width: auto;
    }

    h1, h2, h3, h4, h5 {
        margin: 0; 
        padding: 0; 
        font-weight: ${FontWeight.strong};
    }

    svg path {
        transition: all 0.3s ease;
    }

    ul, li, ol {
        padding: 0; 
        margin: 0;
    }

    .narrow-label label {
        min-width: 50px!important;
    }

    .hidden-label label {
        display: none;
    }
    
    table td {
      .line-clamp {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      .line-clamp-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    
    .pulse-loader {
      &:hover {
        span {      
          background-color: #fff !important;
        }
      }    
    }

   @media only screen and (min-width: 992px) {
        .block-label div:first-of-type {
            flex-direction: column;
            align-items: flex-start;
            gap: .5rem;
        }

        .block-label label {
            display: block;
            min-width: auto;
            flex-basis: 100%;
        }
    }
`;
